<template>
   <router-view/>
</template>

<script>
    import {intercept} from "@/api/interceptor/auth.interceptor";
    import settingApi from "@/api/SettingApi";
    export default {
      name: 'App',
      created() {
        intercept(this.$store);

        settingApi.get().then(setting => {
          this.$store.commit('setConfig', setting);
        });

      }
    };
</script>
<style lang="scss">
    @import 'assets/style/style';
</style>
